// extracted by mini-css-extract-plugin
module.exports = {"value":"BattleTypePicker_value_1qJJO","battleTypeIcon":"BattleTypePicker_battleTypeIcon_1jmW9","item":"BattleTypePicker_item_3scOK"};